// eslint-disable-next-line import/no-unresolved
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@nazka/nazka.mapframe.components';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './pwa-badge.styl';

function PWABadge() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) {
    return null;
  }

  return (
    <div className="pwa-badge z-depth-1" role="alert" aria-labelledby="toast-message">
      <div className="pwa-badge__toast">
        <div className="pwa-badge__toast__message">
          <span id="toast-message">
            {t('A new version of the application is available. Click on the reload button to update.')}
          </span>
        </div>
        <div className="pwa-badge__toast__buttons">
          <Button
            onClick={() => updateServiceWorker(true)}
            css={{
              color: 'white',
              '&:hover': { color: 'white' },
            }}
          >
            {t('Reload')}
          </Button>
          <Button
            layout="outlined"
            onClick={() => setNeedRefresh(false)}
            css={{ '&:hover': { color: 'white' } }}
          >
            {t('Close')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PWABadge;
